/*
          Author: Vaishnavi
          Date: 18/11/2019
          Issue Description: Visual Bug fixes assigned by Harshvardhan Kore & Tarun Bhandari
          */
<template>
<div class="main-container">
  <div>
   <tl-header type="h1">Cost Centres</tl-header>
    <div v-if="showIntro && costCenterData.length==0" class="row-container center">
      <div class="company-info">
        <img class="image" src="@/assets/bands.svg" />
        <div class="fontStyle">
          <br><br><span>Cost centre is a part of an organisation to which costs
            are charged for accounting purposes.
          </span><br>
          <span>preferrences from advance settings in the same section</span>
          <div class="divider"></div><br><br>
          <btn text="Enable" type="secondary" class="rightAlign" v-on:click="goToCostCentresPage"></btn>
        </div>
      </div>
    </div>
    <bottom-action-container class="placeAtEnd" v-if="showIntro">
      <btn-skip @navClicked="skip"></btn-skip>
    </bottom-action-container>
  </div>
  <div v-if="!showIntro || costCenterData.length!=0">
    <cost-center @displayIntro="goToIntro" />
  </div>
</div>
</template>

<script>
import CostCenter from "./crud_cost_centre.vue";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
export default {

  computed: {
    ...mapState({
      costCentreData: state => state.onboard.cost_centres.data,
      GlobalData: state => state.globalapi.globalData.data
    }),
    ...mapState("onboard/legal_entities",{
       isEnable: state=>state.data
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else
          return this.getleid(0);
    }
  },
  data() {
    return {
      showIntro: true,
      costCenterData:[]
    };
  },
  activated(){
      this.fetchCentres();
  },
  components: {
    CostCenter
  },
  methods: {
    ...mapActions({
       fetch: "onboard/cost_centres/fetchAll",
       act_fetch_stepper_status: "onboard/legal_entities/fetchStepperStatus",
       act_enable: "onboard/cost_centres/enable",
    }),
    ...mapMutations("onboard/legal_entities/",{
        enable_le:"updateEntityById"
    }),


   /* function to show intro section */
    goToIntro() {
      this.showIntro = true;
    },

    /* function to hide intro section */
     goToCostCentresPage() {
        this.showIntro = false;
    },

    /* server call to get cost centre */
    async fetchCentres() {
      try {
        let res=await this.fetch(this.le_id);
        if(res){
          this.costCenterData=res.data.payload.data
          this.getStepperStatus();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async getStepperStatus() {
      try {
        let res = await this.act_fetch_stepper_status({le_id: this.le_id, index: this.$route.params.entity_index});
        if (res.data.status) {
          //console.log(res.data.payload.data);
        }
        //console.log({res});
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /* function to skip the step */
    skip(){
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/designation`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.image {
  margin-top: 30px;
}

.row-container {
  .value {
    margin-right: 0;
  }
}

.bottom-content {
  margin-top: 170px;
}

.bottom-content span {
  margin-bottom: 0;
  border-bottom: 1px solid #105ca4;
  border-bottom-color: #105ca4;
  height: 18px;
  font-family: Montserrat;
  font-size: 14px;
  color: #105ca4;
}

.company-info {
  display: flex;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  align-items: flex-start;
  position: relative;
  width: 100%;
}

.closeImage {
  position: absolute;
  float: right;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.building {
  width: 56px;
  height: 58px;
  object-fit: contain;
  margin: 25px 0 0 129px;
}

.fontStyle {
  margin-left: 20px;
  font-family: Montserrat;
  font-size: 16px;
  color: #404040;
}

.divider {
  color: #34c0be;
  border-bottom: 2px solid #34c0be;
  width: 60%;
  margin: 30px 0 0 5px;
}

.placeAtEnd {
  margin-top: 20px;
}
</style>
